import Vue from 'vue';

import EntranceBanner from './EntranceBanner.vue';

new Vue({
	el: '#entrance_banner',
	render: h => h(EntranceBanner),
});
